import React from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';

/**
 * Budget Alert Dialog Component
 */
const BudgetAlertDialog = ({
  isOpen,
  onClose,
  onConfirm,
  cancelRef,
  editButtonLoading,
}) => {
  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />

      <AlertDialogContent>
        <AlertDialogHeader>Save Changes?</AlertDialogHeader>
        <AlertDialogCloseButton />
        <AlertDialogBody>
          Are you sure all the previous data maintained will be deleted?
        </AlertDialogBody>
        <AlertDialogFooter gap={4}>
          <Button ref={cancelRef} onClick={onClose}>
            No
          </Button>
          <Button
            isLoading={editButtonLoading}
            colorScheme="red"
            ml={3}
            onClick={onConfirm}
          >
            Yes
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default BudgetAlertDialog;
